<template>
  <div>
    <div style="page-break-after: always">
      <DashboardCoverPageComponent
        ref="coverPage"
        :companyName="companyName"
        :companyLogo="companyLogo"
        :productType="productType"
        :reportDate="reportDate"
        :reportYear="reportYear"
      />
    </div>

    <template v-if="dashboardTables.length > 0">
      <template
        v-for="(table, tableIndex) in dashboardTables"
        :key="tableIndex"
      >
        <div style="page-break-after: always">
          <div style="min-height: 95vh">
            <DashboardPDFPageComponent
              :companyLogo="companyLogo"
              :productType="productType"
              :reportDate="reportDate"
              :pageName="dashboardPage.PageName"
              :dashboardTable="table"
            />
          </div>
          <DashboardFooterComponent
            :pageNumber="tableIndex + 1"
            :reportDate="reportYear"
          />
        </div>
      </template>
    </template>

    <div style="page-break-after: always">
      <div style="min-height: 95vh">
        <DashboardNotesComponent
          :companyLogo="companyLogo"
          :productType="productType"
          :reportDate="reportDate"
          :pageName="dashboardPage.PageName"
          :pageNotes="dashboardPage.PageNotes"
        />
      </div>
      <DashboardFooterComponent
        :pageNumber="dashboardTables.length + 1"
        :reportDate="reportYear"
      />
    </div>

    <div style="page-break-after: always">
      <TerminologyMethodologyComponent
        :productType="productType"
        :reportDate="reportDate"
        :reportYear="reportYear"
        :pageNumber="dashboardTables.length + 2"
      />
    </div>

    <template v-for="(definition, index) in indicatorDefinitions" :key="index">
      <div style="page-break-after: always">
        <div style="min-height: 90vh">
          <DashboardDefinitionComponent
            :companyLogo="companyLogo"
            :productType="productType"
            :reportDate="reportDate"
            :indicatorDefinitions="definition"
            :isPDF="true"
          />
        </div>
        <DashboardFooterComponent
          :pageNumber="dashboardTables.length + 4 + index"
          :reportDate="reportYear"
        />
      </div>
    </template>

    <div style="min-height: 100vh">
      <!-- style="page-break-after:always;" -->
      <div style="min-height: 95vh">
        <ManagementObjectivesComponent
          :companyLogo="companyLogo"
          :productType="productType"
          :reportDate="reportDate"
        />
      </div>
      <DashboardFooterComponent
        :pageNumber="dashboardTables.length + 4 + indicatorDefinitions.length"
        :reportDate="reportYear"
      />
    </div>
  </div>
</template>
<script>
  import DashboardCoverPageComponent from '~/components/report/modules/live-report/dashboard/DashboardCoverPageComponent.vue';
  import DashboardPDFPageComponent from '~/components/report/modules/live-report/dashboard/pdf/DashboardPDFPageComponent.vue';
  import DashboardDefinitionComponent from '~/components/report/modules/live-report/dashboard/pdf/DashboardDefinitionComponent.vue';
  import ManagementObjectivesComponent from '~/components/report/modules/live-report/dashboard/ManagementObjectivesComponent.vue';
  import TerminologyMethodologyComponent from '~/components/report/modules/live-report/dashboard/TerminologyMethodologyComponent.vue';
  import DashboardFooterComponent from '~/components/report/modules/live-report/dashboard/DashboardFooterComponent.vue';
  import DashboardNotesComponent from '~/components/report/modules/live-report/dashboard/pdf/DashboardNotesComponent.vue';

  export default {
    name: 'DashboardPDFComponent',
    components: {
      DashboardCoverPageComponent,
      DashboardPDFPageComponent,
      DashboardDefinitionComponent,
      ManagementObjectivesComponent,
      TerminologyMethodologyComponent,
      DashboardFooterComponent,
      DashboardNotesComponent,
    },
    props: {
      companyName: String,
      companyLogo: String,
      dashboardPage: Object,
      indicatorDefinitions: Object,
      notes: Array,
      productType: String,
      reportDate: String,
      reportYear: String,
    },
    data() {
      return {
        dashboardTables: [],
      };
    },
    mounted() {
      this.buildDashboardTables();
    },
    methods: {
      // loop through dashboard table to determine how many indicators are put on a PDF page
      buildDashboardTables: function () {
        if (this.dashboardPage?.DashboardTables.length > 0) {
          // loop through each table in api
          for (let i = 0; i < this.dashboardPage.DashboardTables.length; i++) {
            let table = this.dashboardPage.DashboardTables[i];

            let tableGroupLength = 0;
            let isYearEnd = table.IsYearEndTable;
            let marketMetricLength =
              table.Markets.length > 0 ? table.Markets[0].Rows.length : 0;
            let marketQuarterLength =
              marketMetricLength > 0
                ? table.Markets[0].Rows[0].MetricData.length
                : 0;

            // bool - has DT metrics
            let hasDT =
              marketMetricLength > 0 &&
              table.Markets[0].Rows.some((row) => {
                return row.Metric.includes('MMA') || row.Metric.includes('MMT');
              });

            // bool - has Q to Q metrics
            let hasQToQ =
              marketMetricLength > 0 &&
              table.Markets[0].Rows.some((row) => {
                return row.Metric.includes('Q to Q');
              });

            // determine how many rows get put in table group
            if (marketQuarterLength < 16) {
              if (!hasDT && !hasQToQ) {
                tableGroupLength = 10;
              } else if (!hasDT && hasQToQ) {
                tableGroupLength = 8;
              } else if (!hasQToQ && hasDT) {
                tableGroupLength = 6;
              } else if (hasQToQ && hasDT) {
                tableGroupLength = 5;
              }
            } else {
              // marketQuarterLength > 16
              tableGroupLength = 5;
            }

            //loop and build table group
            let indicators = [];
            for (let x = 0; x < table.Markets.length; x++) {
              let indicator = table.Markets[x];

              indicators.push(indicator);

              if (
                indicators.length >= tableGroupLength ||
                x === table.Markets.length - 1
              ) {
                this.dashboardTables.push({
                  HasImportantTrendsText: table.HasImportantTrendsText,
                  Headers: table.Headers,
                  IsYearEndTable: isYearEnd,
                  Markets: indicators,
                  Quarters: null,
                  LongForecast: marketQuarterLength >= 16 ? true : false,
                });

                // reset group
                indicators = [];
              }
            }
          }
        }
      },
    },
  };
</script>
